/* =====================================================================
   Bluewud "Save for later" — cart page only.
   - Adds a "Save for later" action to every cart line: stores the exact
     variant + quantity in BWSaved (source 'sfl'), removes the line via
     /cart/change.js, then reloads (the cart page's totals/savings maths
     is server-rendered, so a reload is the one refresh path that can
     never drift from bluewud-cart.js).
   - Renders a "Saved for later" block at the end of .cartitems (or after
     .cartitems-empty when the cart is empty) with Move-to-cart / Remove.
   Injection-only; guarded to the cart page.
   ===================================================================== */
(function () {
  'use strict';

  function saved() { return window.BWSaved; }

  function onCartPage() {
    return !!(document.querySelector('[data-cart-item-list]') ||
      document.querySelector('.cartitems-empty'));
  }

  function handleFromUrl(url) {
    var match = String(url || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function formatMoney(cents) {
    var n = parseFloat(cents) / 100;
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency', currency: 'INR', maximumFractionDigits: 0
      }).format(n);
    } catch (err) {
      return 'Rs. ' + Math.round(n);
    }
  }

  /* ---- per-line "Save for later" -------------------------------------- */
  function injectLineActions() {
    document.querySelectorAll('.cart-item').forEach(function (line) {
      if (line.querySelector('.bw-sfl-link')) return;
      var key = line.getAttribute('data-cartitem-key');
      var variantId = line.getAttribute('data-cartitem-id');
      var productLink = line.querySelector('a[href*="/products/"]');
      var handle = handleFromUrl(productLink && productLink.getAttribute('href'));
      var host = line.querySelector('.cart-item--content') || line;
      if (!key || !variantId || !handle) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bw-sfl-link';
      btn.textContent = 'Save for later';
      btn.addEventListener('click', function () {
        btn.disabled = true;
        btn.textContent = 'Saving…';
        var qtyInput = line.querySelector('input[name="updates[]"], select[name="updates[]"]');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        saved().add({ handle: handle, variantId: variantId, qty: qty, source: 'sfl' });

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function () { window.location.reload(); })
          .catch(function () {
            /* cart change failed — undo the save so the item isn't in both */
            saved().remove('sfl', variantId);
            btn.disabled = false;
            btn.textContent = 'Save for later';
          });
      });
      host.appendChild(btn);
    });
  }

  /* ---- "Saved for later" block ----------------------------------------- */
  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function buildRow(entry, product) {
    var row = document.createElement('div');
    row.className = 'bw-sfl-row';

    var variant = null;
    (product.variants || []).forEach(function (v) {
      if (String(v.id) === String(entry.variantId)) variant = v;
    });

    var media = document.createElement('a');
    media.className = 'bw-sfl-row__media';
    media.href = product.url;
    var imgSrc = (variant && variant.featured_image && variant.featured_image.src) || product.featured_image;
    if (imgSrc) {
      var img = document.createElement('img');
      img.src = imgSrc + (String(imgSrc).indexOf('?') === -1 ? '?' : '&') + 'width=200';
      img.alt = product.title;
      img.loading = 'lazy';
      media.appendChild(img);
    }
    row.appendChild(media);

    var body = document.createElement('div');
    body.className = 'bw-sfl-row__body';

    var title = document.createElement('a');
    title.className = 'bw-sfl-row__title';
    title.href = product.url;
    title.textContent = product.title;
    body.appendChild(title);

    if (variant && variant.title && variant.title !== 'Default Title') {
      var opts = document.createElement('div');
      opts.className = 'bw-sfl-row__options';
      opts.textContent = variant.title + (entry.qty > 1 ? ' · Qty ' + entry.qty : '');
      body.appendChild(opts);
    }

    var price = document.createElement('div');
    price.className = 'bw-sfl-row__price';
    price.textContent = formatMoney(variant ? variant.price : product.price);
    body.appendChild(price);

    var actions = document.createElement('div');
    actions.className = 'bw-sfl-row__actions';

    var moveBtn = document.createElement('button');
    moveBtn.type = 'button';
    moveBtn.className = 'bw-sfl-row__move';
    var available = variant ? variant.available : product.available;
    if (available) {
      moveBtn.textContent = 'Move to cart';
      moveBtn.addEventListener('click', function () {
        moveBtn.disabled = true;
        moveBtn.textContent = 'Moving…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: parseInt(entry.variantId, 10), quantity: entry.qty || 1 })
        })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function () {
            saved().remove('sfl', entry.variantId);
            window.location.reload();
          })
          .catch(function () {
            moveBtn.disabled = false;
            moveBtn.textContent = 'Move to cart';
          });
      });
    } else {
      moveBtn.textContent = 'Out of stock';
      moveBtn.disabled = true;
    }
    actions.appendChild(moveBtn);

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'bw-sfl-row__remove';
    removeBtn.textContent = 'Remove';
    removeBtn.addEventListener('click', function () {
      saved().remove('sfl', entry.variantId);
      row.remove();
      var block = document.querySelector('.bw-sfl-block');
      if (block && saved().list('sfl').length === 0) block.remove();
    });
    actions.appendChild(removeBtn);

    body.appendChild(actions);
    row.appendChild(body);
    return row;
  }

  function renderBlock() {
    var entries = saved().list('sfl');
    if (!entries.length) return;

    /* Inject into a plain flow container only — .cartitems is the left grid
       CELL (block), .cartitems-empty is the empty state. NEVER a grid child
       (lesson: an extra child in a named-area grid wrecks the layout). */
    var host = document.querySelector('.cartitems') || document.querySelector('.cartitems-empty');
    if (!host || document.querySelector('.bw-sfl-block')) return;

    var block = document.createElement('section');
    block.className = 'bw-sfl-block';
    block.setAttribute('aria-label', 'Saved for later');

    var heading = document.createElement('h2');
    heading.className = 'bw-sfl-block__title';
    heading.textContent = 'Saved for later (' + entries.length + ')';
    block.appendChild(heading);

    var list = document.createElement('div');
    list.className = 'bw-sfl-block__list';
    block.appendChild(list);

    host.appendChild(block);

    entries.forEach(function (entry) {
      fetchProduct(entry.handle).then(function (product) {
        if (product) list.appendChild(buildRow(entry, product));
      });
    });
  }

  function start() {
    if (!saved() || !onCartPage()) return;
    injectLineActions();
    renderBlock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
